import React, {useCallback, useState} from 'react';

import Slider from 'react-slick';

const Testimonial = () => {
  const [mute, setMute] = useState(null);

  const toggleMute = useCallback(
    (index) => () => {
      setMute((state) => (state === index ? null : index));
    },
    [],
  );  

  return (
    <section className="testimonial">
      <div className="small-container">
        <Slider
          arrows
          fade
          infinite={false}
          speed={1000}
          slidesToShow={1}
          slidesToScroll={1}
          afterChange={toggleMute(null)}
        >
          <div>
            <div className="testimonial-inner flex-row no-margin">
              <div className="testimonial-video-area">
                <video className="testimonial-video position-relative"
                  src="/video/testimonial-1.mp4"
                  muted={mute === 0 ? false : true}
                  autoPlay
                  loop
                >
                </video>
                <button type="button" className="mute" onClick={toggleMute(0)}>
                      <img
                        src="/img/mute.svg"
                        alt=""
                        className={`mute-button ${
                          mute === 0 ? `` : `show`
                        }`}
                      />
                      <img
                        src="/img/unmute.svg"
                        alt=""
                        className={`mute-button ${
                          mute === 0 ? `show` : ``
                        }`}
                      />
                    </button>
                  <h5 className="yellow-heading">Merritt - Hackstone</h5>
              </div>
              <div className="testimonial-content-area">
                <div className="testimonial-content ">
                  <span className="big-gradient-circle gradient-anim red-gradient small-gradient" />
                  <span className="big-gradient-circle delay-1 gradient-anim green-gradient " />
                  <img src="/img/apostrophe.svg" alt="" />
                  <h5>
                  ClipHire brings back what has been missing for so long in the recruitment process, in my opinion is the human connection. I love that you're able to personalize videos as well as integrate so many other functions on the platform.
                  </h5>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="testimonial-inner flex-row no-margin">
              <div className="testimonial-video-area">
                <video className="testimonial-video position-relative"
                  src="/video/testimonial-2.mp4"
                  muted={mute === 1 ? false : true}
                  autoPlay
                  loop
                >
                </video>
                <button type="button" className="mute" onClick={toggleMute(1)}>
                      <img
                        src="/img/mute.svg"
                        alt=""
                        className={`mute-button ${
                          mute === 1 ? `` : `show`
                        }`}
                      />
                      <img
                        src="/img/unmute.svg"
                        alt=""
                        className={`mute-button ${
                          mute === 1 ? `show` : ``
                        }`}
                      />
                    </button>
                  <h5 className="yellow-heading">Molly - Wonsupona</h5>
              </div>
              <div className="testimonial-content-area">
                <div className="testimonial-content ">
                  <span className="big-gradient-circle gradient-anim red-gradient small-gradient" />
                  <span className="big-gradient-circle delay-1 gradient-anim green-gradient " />
                  <img src="/img/apostrophe.svg" alt="" />
                  <h5>
                  The video platform is intuitive, easy to use and it makes it very simple to peer into the person behind the resume so that you can understand immediately is the person is going to be a great fit for your company.
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </Slider>
      </div>
    </section>
  );
};

export default Testimonial;
